import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { LocaleProvider } from 'antd'
import ruRU from 'antd/lib/locale-provider/ru_RU'

import Layout from '../layout'
import Login from '../login'

export const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 14 },
  },
};
export const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 14,
      offset: 6,
    },
  },
}

const App = () => (
  <LocaleProvider locale={ruRU}>
    <Switch>
      <Route exact path='/login' component={Login} />
      <Route path='/' component={Layout} />
    </Switch>
  </LocaleProvider>
)

export default App



// WEBPACK FOOTER //
// ./src/containers/app/index.js